/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import React from 'react'
import UserCard from '@/components/conversation-insights/user-card';
import DeltaArrowIcon from '@/components/conversation-insights/delta-arrow';
import { cn, hasValidKey } from '@/lib/utils';
import { Member, Option } from '@/utils/types';
import { useIsMobile } from '@/hooks/useIsMobile';

const MemberItem = ({
    workspaceUsersObj,
    member,
    insightsFilters,
    handleLeaderboardUserClick,
    handleLeaderboardUserRemove,
  }: {
    workspaceUsersObj: { [key: string]: Option };
    member: Member;
    insightsFilters: any;
    handleLeaderboardUserClick: Function;
    handleLeaderboardUserRemove: Function;
  }) => {
    const isMobile = useIsMobile();
    const isSelected = insightsFilters?.conversation_owner_ids?.includes(member?.user_id)
    
    return (
    <div
      className={cn("w-full p-3 border border-[#E4E4E7] flex items-center justify-start gap-4 rounded-[12px] cursor-pointer",
         {'bg-gray-200': isSelected, 'flex-col items-start': isMobile}
        )}
      onClick={()=>{
        if(isSelected){
          handleLeaderboardUserRemove(member?.user_id);
        } else {
          handleLeaderboardUserClick(member?.user_id);
        }
      }}
    >
      {workspaceUsersObj?.[member?.user_id] && (
        <UserCard 
         user={workspaceUsersObj?.[member?.user_id]} 
         showEmail 
         truncate
        />
      )}
      {(hasValidKey(member, 'value') || hasValidKey(member, 'percentage')) && (
        <div className={cn("flex flex-col gap-1", {'flex-row-reverse justify-between items-center gap-4 w-full': isMobile})}>
          <div className="flex items-center gap-1">
            <p className="text-base font-medium">
              {hasValidKey(member, "percentage") ? `${member?.percentage}%` : member?.value}
            </p>
            {hasValidKey(member, "changes") && (
              <span
                className={`text-xs flex items-center gap-1 ${
                  (member?.changes || 0) < 0 ? "text-[#F0412F]" : (member?.changes || 0) > 0 ? 'text-[#34A853]' : 'text-[#8A919F]'
                }`}
              >
                {member?.changes}%
                {member?.changes !== 0 && (
                  <DeltaArrowIcon className={`w-4 h-3 ${(member?.changes || 0) < 0 ? 'fill-[#F0412F] scale-x-[-1] rotate-180' : 'fill-[#34A853]'}`}/>
                )}
              </span>
            )}
          </div>
          <span className="text-xs font-normal text-[505056]">
            {member?.label}
          </span>
        </div>
      )}
    </div>
  )};

export default MemberItem